import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  addNewCompanyClient: () => __(translations.picker.directory.addNewCompanyClient, 'Add Company'),
  addNewPrivateClient: () => __(translations.picker.directory.addNewPrivateClient, 'Add Private'),
};
